import { Linkable } from "@/components/blocks/Linkable";
import { useLocalization } from "@/data/Localization";
import { ID } from "@/data/types/Basic";
import { Button, Paper, Stack, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import { catNavCategoryMobSX, catNavCategorySX, catNavContainerMobSX, catNavContainerSX, catNavHeaderSX } from "./style/container";
import { combineSX } from "@/utils/combineSX";
import { useFacetNavigation } from "@/data/Content/FacetNavigation";
import { usePageDataFromId } from "@/data/_PageDataFromId";
import { CATEGORY_NAVIGATION_INITIAL_DISPLAY_LIMIT } from "@/data/constants/categoryNavigation";
import { useDeviceType } from "@/data/deviceDetection";

export const CategoryNavigationRv:FC<{id:ID}> = ({id}) => {
    const categoryNLS = useLocalization("Category");
    const productFilterNLS = useLocalization('ProductFilter');
    const {isMobile} = useDeviceType();

    const {data:pageData} = usePageDataFromId();
    const {facets} = useFacetNavigation(id);
    const facetsC = useMemo(()=>facets?.find(f => f.name === "ParentCatalogGroup"),[facets]);
    
    const catNav = facetsC?.entry.map(facetEntry => {
        const facetPId = facetEntry?.extendedData?.parentIds?.split("_")?.at(-1);
        return facetPId===id || pageData?.page.type==="SearchPage" ?{
            label: facetEntry.label,
            url:facetEntry.x_seoPath,
            count: facetEntry.count
        }:{}
    }).filter(c => c.url && c.url !== "").filter(Boolean);
    
    
    const showMore = useMemo(()=>(catNav?.length??0)>CATEGORY_NAVIGATION_INITIAL_DISPLAY_LIMIT?true:false,[catNav]);

    const showAllCategories = () => {
        const mainElem = document.querySelector("#category_navigation_widget") as HTMLElement;
        if(mainElem!==null){
            ([...mainElem.childNodes] as HTMLElement[]).forEach((c)=>{
                c.classList.remove("hidden")
            });
            const showMoreElem = document.querySelector("#category_navigation_show_more") as HTMLElement;
            if(showMoreElem!==null){
                showMoreElem.style.display = 'none';
            }
        }
    }
    return (
        catNav && catNav?.length>0?
            <Paper
                sx={combineSX(isMobile?[catNavContainerSX, catNavContainerMobSX]:[catNavContainerSX])}
                id="category_navigation_widget"
            >
                <Typography variant="h6" sx={catNavHeaderSX}>{categoryNLS.Category.t()}</Typography>
                {catNav.map((c,i)=>
                    <Stack
                        key={i}
                        direction="row" 
                        sx={combineSX(isMobile?[catNavCategorySX, catNavCategoryMobSX]:[catNavCategorySX])}
                        className={(i>(CATEGORY_NAVIGATION_INITIAL_DISPLAY_LIMIT-1))?'hidden':''}
                    >
                        <Linkable href={c.url}>
                            <Typography fontSize={15}>{c.label}&nbsp;&#40;{c.count}&#41;</Typography>
                        </Linkable>
                    </Stack>
                )}
                {showMore && facetsC ? (
                    <Button
                        variant="inline"
                        data-testid={`category_navigation_show_more`}
                        id={`category_navigation_show_more`}
                        onClick={showAllCategories}
                    >
                        {productFilterNLS.Actions.showMore.t()}
                    </Button>
                ) : null}
            </Paper>
        :null
    )
}